
import { useMemo } from "react";
import axios from "axios";
import { message } from "antd";
import { HS_CRM_API_URL } from "../constants/AppConstants";

const useHsCrmApi = () => {
  const domainUrl = HS_CRM_API_URL;

  const api = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const companyId = urlParams.get("companyId");
    const userId = urlParams.get("userId");
    const headers = {
      "Content-Type": "application/json",
    };
    if (companyId && userId) {
      headers["hs-orgId"] = companyId + "_" + userId;
    }

    const axiosInstance = axios.create({
      baseURL: `${domainUrl}/v1`,
      headers,
      withCredentials: true,
    });

    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        console.error("API Error:", error);
        if (error.response?.status === 401) {
          console.error("Unauthorized access - Please login again");
          message.error("Unauthorized access - Please login again");
        } else if (error.response?.status === 403) {
          const errorMessage =
            error.response?.data?.message || error.response?.data?.error || "You don't have permission to perform this action";
          console.error("Forbidden:", errorMessage);
          message.error(errorMessage);
        } else if (error.response?.data?.title === "ACCESS_DENIED") {
          message.error(error.response?.data?.detail || "You don't have permission to perform this action");
        } else if (error.code === "ERR_CANCELED") {
          console.error("Search request was aborted");
        }

        throw error;
      }
    );

    return axiosInstance;
  }, [domainUrl]);

  return {
    api,
  };
};

export default useHsCrmApi;
